import { Component, OnInit } from '@angular/core';
import { InvalidCredentialsError } from '../../../../-services-/auth-framework/auth-errors';
import { AuthProviderService } from '../../../../-services-/auth-framework/auth-provider.service';
import { LoginPageService } from '../../login-page.service';
import { extractErrorText } from '../../../../utilities/extract-error-text';
import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-mfa-form',
  templateUrl: './mfa-form.component.html',
  styleUrls: ['./mfa-form.component.css']
})
export class MfaFormComponent implements OnInit {
  invalid = false;
  errorMessage!: string;
  loading = false;
  emailCodeSent = false;

  inputValue!: string;

  constructor(private authProvider: AuthProviderService, public loginPageService: LoginPageService, private messageService: MessageService, private http: HttpClient) {}

  ngOnInit(): void {}

  async sendCodeToEmail(): Promise<void> {
    try {
      await firstValueFrom(this.http.post('mfa/email-mfa', {}));
      
      this.emailCodeSent = true;
      this.messageService.add({
        severity: 'success',
        summary: 'Code Sent',
        detail: 'MFA code has been sent to your email address.'
      });
    } catch (e) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to send code to email. Please try again.'
      });
      console.error('Error sending MFA code to email:', e);
    }
  }

  async onConfirm(): Promise<void> {
    try {
      this.loading = true;
      this.invalid = false;

      this.loginPageService.mfaToken = this.inputValue;
      await this.authProvider.logIn(
        this.loginPageService.username,
        this.loginPageService.password,
        this.loginPageService.acceptToS,
        this.loginPageService.mfaToken
      );
      this.loginPageService.loginSuccess.emit();
    } catch (e) {
      this.loading = false;
      this.invalid = true;

      if (e instanceof InvalidCredentialsError) {
        const errorText = extractErrorText(e);
        this.errorMessage = errorText.includes('Services will resume shortly')
          ? errorText
          : `That doesn't look right: ${errorText}`;
      } else {
        const rawMessage = extractErrorText(e);
        if (rawMessage === 'jwt expired') {
          // redirect to login form
          this.messageService.add({
            severity: 'warn',
            summary: 'Message',
            detail: 'Session expired. Please relogin.'
          });
          this.loginPageService.state = 'ROOT';
        }
        this.errorMessage = `Sorry, an error occurred. ${rawMessage}`;
        console.error(e);
      }
      console.error(e);
    }
  }
}
